import React from 'react';
import './style/style.scss';

const Loader = () => (
    <div>
        <span className="spinner tds-icon-loader-1-static-red-18" ></span>
    </div >
);

export default Loader;